import '../stylesheets/frontend/pair_show.css.scss'
import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'

import ReactOnRails from 'react-on-rails'
import LargeChart from '../bundles/components/chart/LargeChart'
import PairRateFrame from '../bundles/components/PairRateFrame'
import PairRateHeaderPC from '../bundles/components/PairRateHeader/pc'
import PairRateHeaderSP from '../bundles/components/PairRateHeader/sp'
import CoinIcon from '../bundles/components/shared/CoinIcon'
import TipIcon from '../bundles/components/shared/TipIcon'
import ChatFrame from '../bundles/components/chat/ChatFrame'
import PredictionBar from '../bundles/components/prediction/PredictionBar'
import PairMarketsTable from '../bundles/components/PairMarketsTable'
import PairStatusPC from '../bundles/components/PairStatus/pc'
import SidebarPairsTable from '../bundles/components/SidebarPairsTable'
import SidebarPairsDeviation from '../bundles/components/SidebarPairsTable/deviation_up'

const application = Application.start()
const context = require.context(
  'controllers',
  true,
  /^(?!.*\/admin\/).*_controller\.(js|ts)$/
)
application.load(definitionsFromContext(context))

ReactOnRails.register({
  LargeChart,
  PairRateFrame,
  PairRateHeaderPC,
  PairRateHeaderSP,
  CoinIcon,
  TipIcon,
  ChatFrame,
  PredictionBar,
  PairMarketsTable,
  PairStatusPC,
  SidebarPairsTable,
  SidebarPairsDeviation,
})
